import { CandidateBatchStatus } from 'generated-graphql/types';

export const getAnalysisStatusLabel = (
  status: CandidateBatchStatus
): string => {
  switch (status) {
    case CandidateBatchStatus.Draft:
      return 'Draft';
    case CandidateBatchStatus.Live:
    case CandidateBatchStatus.FinishedRankingCandidates:
      return 'Live';
    case CandidateBatchStatus.Archived:
      return 'Archived';
    case CandidateBatchStatus.Paused:
      return 'Archived'; // PAUSED displays as Archived
    case CandidateBatchStatus.RankingCandidates:
    case CandidateBatchStatus.PreProcessing:
    case CandidateBatchStatus.ReadyToProcess:
    case CandidateBatchStatus.Created:
      return 'Processing';
    default:
      return 'Unknown';
  }
};
